import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm'
import ProjectsSchema from 'schemas/trackingInfo.schema.json'
import { updateProjectInfo } from 'utils/DetailsUtils'
import { useFormContext } from 'hooks/useFormContext'
import SkeletonForm from 'components/Shared/SkeletonForm'
import { useAppContext } from 'hooks/useAppContext';
import { useCanDoAction } from 'hooks/useCanDoAction';

const Tracking = ({ orientation, defaultValues, CRUDType, callback, disabledProperties, hiddenProperties }) => {
    const formContext = useFormContext();
    const { selectedProject } = useAppContext();
    const canEdit = useCanDoAction('Projects', 'update');

    useEffect(() => {
        !formContext.schema && formContext.updateSchema(ProjectsSchema)
    });

    const onSubmit = async (values) => {
        let result

        values.ProjectId = defaultValues.ProjectId
        values.StateId = defaultValues.StateId
        values.OrganizationId = defaultValues.OrganizationId
        values.ProjNumber = defaultValues.ProjNumber
        values.ProjectName = defaultValues.ProjectName
        values.TaskNumber = defaultValues.TaskNumber
        values.ProjectTypeId = defaultValues.ProjectTypeId
        values.PriorityId = defaultValues.PriorityId
        values.ProjectStatusId = defaultValues.ProjectStatusId
        values.Description = defaultValues.Description
        values.ProjectPhaseId = defaultValues.ProjectPhaseId
        values.UserGroupId = defaultValues.UserGroupId
        values.EstStartDate = values.EstStartDate !== null ? new  Date(values.EstStartDate).toLocaleDateString("en-US") : ""
        values.EstCompDate =values.EstCompDate !== null ?  new  Date(values.EstCompDate).toLocaleDateString("en-US") : ""
        values.ActualStartDate = values.ActualStartDate !== null ?  new  Date(values.ActualStartDate).toLocaleDateString("en-US") : ""
        values.ActualCompDate = values.ActualCompDate !== null ?  new  Date(values.ActualCompDate).toLocaleDateString("en-US") : ""
        result = await updateProjectInfo(values, selectedProject)
        setTimeout(callback, 1000)
        return result
    }
    return <div style={{ padding: '15px' }}>

        {formContext.ready ?
            withExtension(DynamicForm, { schema: ProjectsSchema, orientation: "Horizontal", onSubmit, defaultValues, disabledProperties,
            hiddenProperties, definitions: formContext.definitions, readOnly: true, readOnlyEdit: canEdit, title: true }) :
            <SkeletonForm />
        }
    </div>
}

Tracking.propTypes = {
    orientation: PropTypes.string,
    defaultValues: PropTypes.object,
    CRUDType: PropTypes.oneOf(['INSERT', 'UPDATE']).isRequired,
    callback: PropTypes.func,
    disabledProperties: PropTypes.array,
    hiddenProperties: PropTypes.array
}

Tracking.defaultProps = {
    orientation: "Vertical",
    callback: () => { },
    defaultValues: {},
    disabledProperties: [],
    hiddenProperties: []
}

export default Tracking